export interface IDelayedAnimateRef {
    fadeIn: (delay: number, immediate?: boolean) => Promise<void>
    fadeOut: (delay: number, immediate?: boolean) => Promise<void>
}

export interface IAnimateRef {
    fadeIn: (immediate?: boolean) => Promise<void>
    fadeOut: (immediate?: boolean) => Promise<void>
}

export interface IGameItem {
    key: string
    name: string
    description: string
    image: string
}

export interface IGameEquip extends IGameItem {
    // type: "attack" | "guard" | "health"
    type: string
}

export interface IGameBlueprint {
    key: string
    materials: string[]
    result: string
    description?: string
}

export enum EGameScene {
    TRAIL = "trail",
    DIALOG = "dialog",
    CRAFT = "craft",
    DIALOG_BOSS = "dialogBoss",
    RESULT = "result",
    END_GAME = "endGame",
}

export interface IGameResult {
    key: string
    nameCn: string
    nameEn: string
    image: string
    description: string
    toast: string[]
    resultDesc: string
}

export interface IGameDialogUnit {
    key: string
    character: string
    characterName?: string
    description: string
    next: string
    choice?: { key: string; description: string; next: string }[]
    gainItem?: string
}

export interface IGameDialog {
    key: string
    start: string
    question: string
    dialog: Record<string, IGameDialogUnit>
    character: string
    next: string
    image: string
}

export interface IGameCharacter {
    key: string
    name: string
    enName: string
    shareDescription: string
    themeColor: string
}

export type THistory =
    | {
          choice: string[]
          active: number
      }
    | {
          character: string
          description: string
      }

export interface IGameGift {
    key: string
    name: string
    image: string
}
